import React from "react";
import { Formik, Field, Form } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";
import Select from "react-select";

/**
 * Formulário de filtros específico para o relatório de Contas a Receber.
 * Campos: Ordenar, Pessoas, Grupo de Clientes, Moeda (com "Ambas"),
 *         Período Inicial/Final, Enviada há (dias), Banco, PDFs Separados.
 */
export default function FormContasReceber({
  porOptions,
  pessoasOptions,
  gruposOptions,
  moedasOptions,
  bancosOptions,
  por,
  clientes,
  grupo,
  moedaSelecao,
  periodoInicial,
  periodoFinal,
  faturadaHaDias,
  banco,
  pdfsSeparados,
  pessoasOptionsTexto,
  gruposOptionsTexto,
  moedasOptionsTexto,
  bancosOptionsTexto,
  onPorChange,
  onPessoasChange,
  onRemoverPessoa,
  onGrupoChange,
  onMoedaChange,
  onPeriodoInicialChange,
  onPeriodoFinalChange,
  onFaturadaHaDiasChange,
  onBancoChange,
  onPdfsSeparadosChange,
  onPessoasInputChange,
  onGruposInputChange,
  onMoedasInputChange,
  onBancosInputChange,
  pessoas,
  filterSearch,
  onSubmit,
  validForm,
}) {
  return (
    <Formik
      initialValues={{ name: "" }}
      onSubmit={async () => {
        await new Promise((r) => setTimeout(r, 1000));
        onSubmit();
      }}
    >
      <Form className="contact-form">
        <div className="row">
          <div className="col-xl-2 col-lg-2 col-md-2 col-sm-2 col-2"></div>
          <div className="col-xl-8 col-lg-8 col-md-8 col-sm-8 col-12">
            <div className="row addservicos">
              {/* Ordenar */}
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm firstLabel">
                <label>Ordenar:</label>
              </div>
              <div className="col-1 errorMessage">
                {!por && <FontAwesomeIcon title="Preencha o campo" icon={faExclamationTriangle} />}
              </div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                <Select
                  className="SearchSelect"
                  options={porOptions}
                  value={porOptions.find((o) => o.value == por)}
                  search={true}
                  onChange={(e) => onPorChange(e.value)}
                />
              </div>
              {/* Pessoas (multi-seleção) */}
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                <label>Pessoas</label>
              </div>
              <div className="col-1 errorMessage"></div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                <Select
                  className="SearchSelect"
                  options={pessoasOptions
                    .filter((e) => filterSearch(e, pessoasOptionsTexto))
                    .slice(0, 20)}
                  onInputChange={(e) => onPessoasInputChange(e)}
                  search={true}
                  onChange={(e) => onPessoasChange(e.value)}
                />
                <div style={{ marginBottom: 0, color: "white", fontSize: 13 }}>
                  {clientes.map((clienteId, i) => (
                    <span
                      key={clienteId}
                      className="click_to_erase"
                      onClick={() => onRemoverPessoa(clienteId)}
                    >
                      {`${pessoas.find((p) => p.Chave == clienteId)?.Nome || clienteId}${i != clientes.length - 1 ? ", " : " "}`}
                    </span>
                  ))}
                </div>
              </div>

              {/* Grupo de Clientes */}
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                <label>Grupo de Clientes</label>
              </div>
              <div className="col-1 errorMessage"></div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                <Select
                  className="SearchSelect"
                  options={gruposOptions
                    .filter((e) => filterSearch(e, gruposOptionsTexto))
                    .slice(0, 20)}
                  onInputChange={(e) => onGruposInputChange(e)}
                  value={gruposOptions.find((o) => o.value == grupo)}
                  search={true}
                  onChange={(e) => onGrupoChange(e.value)}
                />
              </div>
              {/* Moeda */}
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                <label>Moeda</label>
              </div>
              <div className="col-1 errorMessage"></div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                <Select
                  className="SearchSelect"
                  options={moedasOptions
                    .filter((e) => filterSearch(e, moedasOptionsTexto))
                    .slice(0, 20)}
                  onInputChange={(e) => onMoedasInputChange(e)}
                  value={moedasOptions.find((o) => o.value == moedaSelecao)}
                  search={true}
                  onChange={(e) => onMoedaChange(e)}
                />
              </div>

              {/* Espaçador visual antes dos campos de data */}
              <div style={{ marginTop: 20 }}></div>
              {/* Período Inicial (Vencimento) */}
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                <label>Vencimento Inicial</label>
              </div>
              <div className="col-1 errorMessage"></div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                <Field
                  className="form-control"
                  type="date"
                  value={periodoInicial}
                  onChange={(e) => onPeriodoInicialChange(e.target.value)}
                />
              </div>
              {/* Período Final (Vencimento) */}
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                <label>Vencimento Final</label>
              </div>
              <div className="col-1 errorMessage"></div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                <Field
                  className="form-control"
                  type="date"
                  value={periodoFinal}
                  onChange={(e) => onPeriodoFinalChange(e.target.value)}
                />
              </div>
              {/* Enviada há (dias) */}
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                <label>Enviada há (dias)</label>
              </div>
              <div className="col-1 errorMessage"></div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                <Field
                  className="form-control"
                  type="number"
                  min="0"
                  placeholder="Ex: 30 (deixe vazio para ignorar)"
                  value={faturadaHaDias || ''}
                  onChange={(e) => onFaturadaHaDiasChange(e.target.value)}
                />
              </div>
              {/* Banco */}
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                <label>Banco</label>
              </div>
              <div className="col-1 errorMessage"></div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                <Select
                  className="SearchSelect"
                  options={bancosOptions
                    .filter((e) => filterSearch(e, bancosOptionsTexto))
                    .slice(0, 50)}
                  onInputChange={(e) => onBancosInputChange(e)}
                  value={bancosOptions.find((o) => o.value == banco) || bancosOptions[0]}
                  search={true}
                  onChange={(e) => onBancoChange(e.value)}
                />
              </div>
              {/* PDFs Separados */}
              <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12 labelForm">
                <label>PDFs Separados</label>
              </div>
              <div className="col-1 errorMessage"></div>
              <div className="col-xl-6 col-lg-6 col-md-6 col-sm-10 col-10">
                <Field
                  type="checkbox"
                  className="form-check-input"
                  style={{ marginLeft: "2px", width: "36px", height: "10px" }}
                  checked={pdfsSeparados}
                  onChange={(e) => onPdfsSeparadosChange(e.target.checked)}
                />
                <label className="form-check-label" style={{ marginLeft: "60px", fontSize: "12px", color: "#666" }}>
                  Gerar um PDF para cada cliente
                </label>
              </div>
            </div>
          </div>
          <div className="col-xl-2 col-lg-2 col-md-2 col-sm-1 col-1"></div>
        </div>
        {/* Botão Gerar */}
        <div className="row">
          <div className="col-2"></div>
          <div className="col-8" style={{ display: "flex", justifyContent: "center" }}>
            <button
              disabled={!validForm}
              type="submit"
              style={validForm ? { width: 300 } : { backgroundColor: "#eee", opacity: 0.3, width: 300 }}
            >
              Gerar
            </button>
          </div>
          <div className="col-2"></div>
        </div>
      </Form>
    </Formik>
  );
}